import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'

export default function Footer() {
    return (
        <Container fluid className=' footer-container justify-content-center' >
            <Container>
                <Row className='footer-row justify-content-center' >
                    <Col className='footer-col' >
                        <h3> Follow us </h3>
                        <div>
                            <a style={{textDecoration: 'none'}} href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer" > <img className='footer_social_icon' src="/images/icons/facebook.svg" alt='Loading..' /> </a>
                            <a style={{textDecoration: 'none'}} href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer"> <img className='footer_social_icon' src="/images/icons/instagram.svg" alt='Loading..' /> </a>
                            <a style={{textDecoration: 'none'}} href="https://www.linkedin.com/in/" target="_blank" rel="noopener noreferrer"  > <img className='footer_social_icon' src="/images/icons/linkedin.svg" alt='Loading..' /></a>
                        </div>
                    </Col>
                    <Col className='footer-col'>
                        <h3> Company </h3>
                        <Link to="/about" className='footer-col-link'> About us </Link> <div/>
                        <Link to="/contact" className='footer-col-link'> Contact </Link> <div/>
                    </Col>
                    <Col className='footer-col'>
                        <h3> Quick links </h3>
                        <Link to="/services" className='footer-col-link'> Services </Link> <div/>
                        <Link to="/client" className='footer-col-link'> Our Clients </Link> <div/>
                    </Col>
                </Row>
                <Row className='justify-content-center' >
                        <img className='footer-img' src='/images/logo1.png' alt="Loading.." />
                         <p className=' footer-p justify-content-center text-center'> ©2014 Royality Technologies | All Rights Reserved  </p>
                </Row>
            </Container>
        </Container>
    )
}
